import { KatapultElement, html } from '../../mixins/katapult-element';
import { Debouncer } from '@polymer/polymer/lib/utils/debounce.js';
import { timeOut } from '@polymer/polymer/lib/utils/async.js';
import { KatapultEditorTemplate } from './katapult-editor-template';

import { FirebaseEncode } from '../../modules/FirebaseEncode.js';

import '../icon-picker-dialog/icon-picker-dialog.js';
import '../katapult-color-picker/katapult-color-picker-dialog.js';
import '../paper-table/paper-table.js';
import '../style-modules/paper-table-style';
import '../katapult-elements/katapult-button.js';

import { LazySet } from '../../modules/LazySet.js';
import { Path } from '../../modules/Path.js';
import { GetNewAttributeValue } from '../../modules/GetNewAttributeValue.js';
import { ToArray } from '../../modules/ToArray.js';
import '../katapult-elements/katapult-icon.js';
import '@shoelace-style/shoelace/dist/components/tooltip/tooltip.js';
import '@shoelace-style/shoelace/dist/components/alert/alert.js';
import { KatapultCustomFunctionEditorStep } from './katapult-custom-function-editor-step.js';
import './tags/model-item-tag-selector.js';

class KatapultToolEditor extends KatapultEditorTemplate {
  static get template() {
    return html`
      ${super.style}
      <style include="paper-table-style">
        .dialog-option {
          min-width: 5.14em;
        }
        code.selectable-code {
          user-select: all;
          background-color: var(--sl-color-neutral-100);
          border-radius: var(--sl-border-radius-medium);
          padding: var(--sl-spacing-3x-small);
        }
      </style>

      <katapult-firebase-worker path="[[modelSpaceDetails.path]]/models/attributes" data="{{otherAttributes}}"> </katapult-firebase-worker>
      <katapult-firebase-worker path="[[modelSpaceDetails.path]]/models/button_groups" data="{{toolsets}}"> </katapult-firebase-worker>
      <katapult-firebase-worker path="[[modelSpaceDetails.path]]/models/quality_control" data="{{qualityControlModules}}">
      </katapult-firebase-worker>

      <icon-picker-dialog
        id="iconPickerDialog"
        model-key="[[modelSpaceDetails.$key]]"
        on-icon-selected="iconSelected"
        fit-into="[[$this]]"
      ></icon-picker-dialog>
      <katapult-color-picker-dialog id="colorPickerDialog" on-save="colorSelected" fit-into="[[$this]]"></katapult-color-picker-dialog>

      <template is="dom-repeat" items="[[steps]]" as="step">
        <katapult-editor-step
          creating-item="[[creatingItem]]"
          active="[[step.active]]"
          index="[[step.index]]"
          current-index="[[currentIndex]]"
          title="[[step.title]]"
        >
          <template is="dom-if" if="[[equal(step.id, 'tool_action')]]" restamp>
            <template is="dom-if" if="[[!equal(toolAction, 'custom_function')]]">
              <paper-radio-group selected="{{toolAction}}" slot="body">
                <paper-radio-button name="node">Draw Node</paper-radio-button>
                <paper-radio-button name="connection">Draw Connection</paper-radio-button>
                <paper-radio-button name="node_and_connection">Draw Node & Connection</paper-radio-button>
                <paper-radio-button name="insert_node">Insert Node</paper-radio-button>
                <paper-radio-button name="section">Insert Section</paper-radio-button>
                <paper-radio-button name="run_qc_modules">Run QC Modules</paper-radio-button>
                <paper-radio-button name="web_tool">Run Web Tool</paper-radio-button>
              </paper-radio-group>
            </template>
            <template is="dom-if" if="[[equal(toolAction, 'custom_function')]]">
              <paper-row style="font-style: italic" slot="body">
                <paper-cell icon>
                  <iron-icon style="color: var(--primary-text-color-faded);" icon="editor:functions"></iron-icon>
                </paper-cell>
                <paper-cell>This tool executes a custom function and cannot be modified</paper-cell>
              </paper-row>
            </template>
          </template>

          <template is="dom-if" if="[[equal(step.id, 'tool_configuration')]]" restamp>
            <div slot="body" style="display: flex; flex-direction: column;">
              <template is="dom-if" if="[[_itemData.model_description]]">
                <p style="font-style: italic; margin-bottom: 36px;">[[_itemData.model_description]]</p>
              </template>
              <paper-table style="overflow: hidden;" rounded outline white dividers>
                <paper-row short grey>
                  <paper-cell>[[camelCase(_itemData.model_key_attribute)]]</paper-cell>
                  <paper-cell>[[camelCase(_itemData.model_value_attribute)]]</paper-cell>
                </paper-row>
                <template is="dom-repeat" items="[[modelsArray]]">
                  <paper-row>
                    <paper-cell>[[item.$key]]</paper-cell>
                    <paper-cell>
                      <input-element
                        attribute_name="[[_itemData.model_value_attribute]]"
                        hide-attribute-name
                        value="{{item.$val}}"
                        model="[[getSub(otherAttributes, _itemData.model_value_attribute)]]"
                        other-attributes="[[otherAttributes]]"
                        user-group="[[userGroup]]"
                        no-label-float
                        can-add-attribute
                        on-add-new-attribute="createNewPicklistItem"
                        camel-case
                        on-input-element-change="modelValueChanged"
                        job-creator="[[modelSpaceDetails.$key]]"
                      ></input-element>
                    </paper-cell>
                  </paper-row>
                </template>
              </paper-table>
            </div>
          </template>

          <template is="dom-if" if="[[equal(step.id, 'qc_modules')]]" restamp>
            <katapult-button on-click="nextStep" slot="current-step-header" class="dialog-option">Skip</katapult-button>
            <div style="width: 400px; color: var(--primary-text-color-faded);" slot="body">
              <paper-table light-grey rounded outline>
                <paper-row input>
                  <paper-cell>
                    <katapult-drop-down
                      items="[[qualityControlModules]]"
                      label-function="[[camelCaseKey]]"
                      value-path="$key"
                      label="Select a QC Module"
                      no-label-float
                      on-selected-changed="qcModuleSelectedChanged"
                    ></katapult-drop-down>
                  </paper-cell>
                </paper-row>
              </paper-table>
              <template is="dom-if" if="[[_itemData.qc_modules.length]]">
                <paper-table style="margin-top: 24px; overflow: hidden; flex-grow: 1;" rounded outline white dividers>
                  <paper-row raised-on-scroll grey>
                    <paper-cell icon><iron-icon icon="icons:swap-vert"></iron-icon></paper-cell>
                    <paper-cell>Module Name</paper-cell>
                    <paper-cell icon></paper-cell>
                  </paper-row>
                  <paper-table-scroll on-sort-changed="qcModulesArraySorted">
                    <template is="dom-repeat" items="[[_itemData.qc_modules]]">
                      <paper-row raised-on-scroll slot="sortable">
                        <paper-cell drag-handle icon>
                          <span>[[add(index, 1)]]</span>
                        </paper-cell>
                        <paper-cell>
                          <span>[[camelCase(item.key)]]</span>
                        </paper-cell>
                        <paper-cell icon-button>
                          <katapult-button iconOnly noBorder icon="delete" on-click="removeQCModule"></katapult-button>
                        </paper-cell>
                      </paper-row>
                    </template>
                  </paper-table-scroll>
                </paper-table>
              </template>
            </div>
          </template>

          <template is="dom-if" if="[[equal(step.id, 'endpoint_url')]]" restamp>
            <div slot="body" style="display: flex; flex-direction: column; gap: var(--sl-spacing-medium);">
              <paper-table light-grey rounded outline>
                <paper-row>
                  <paper-cell>
                    <paper-input
                      style="width: 500px;"
                      id="endpointUrlInput"
                      label="Input a URL to a valid endpoint along with any desired parameters"
                      value="{{_itemData.endpoint_url}}"
                      no-label-float
                    ></paper-input>
                  </paper-cell>
                </paper-row>
              </paper-table>

              <div style="display: flex; flex-direction: column; gap: var(--sl-spacing-medium);">
                <sl-alert variant="warning" open>
                  <katapult-icon slot="icon" color="var(--sl-color-warning)" icon="warning"></katapult-icon>
                  <div>URLs are not private! Anyone with access to this model may discover this.</div>
                </sl-alert>

                <sl-alert class="help-text" variant="info" open>
                  <div style="display: flex; flex-direction: column; gap: var(--sl-spacing-x-small);">
                    <div><strong>Possible Parameters (Optional)</strong></div>
                    <div>Include the job id with the following parameter: <code class="selectable-code">$(job_id)</code></div>
                    <div>Include one of the following parameters to prompt the user to select an entity:</div>
                    <ul style="margin: 0; padding-left: var(--sl-spacing-x-large);">
                      <li><code class="selectable-code">$(node_id)</code></li>
                      <li><code class="selectable-code">$(connection_id)</code></li>
                      <li><code class="selectable-code">$(section_id)</code></li>
                    </ul>
                    <div>Include the user's API key with the following parameter: <code class="selectable-code">$(api_key)</code></div>
                    <div>Note: the user will be warned if they do not have a valid Katapult Pro API key.</div>
                  </div>
                </sl-alert>
              </div>
            </div>
          </template>

          <template is="dom-if" if="[[equal(step.id, 'endpoint_action')]]" restamp>
            <paper-cell slot="body">
              <paper-radio-group selected="{{_itemData.endpoint_action}}">
                <paper-radio-button name="API_CALL">API Call</paper-radio-button>
                <paper-radio-button name="OPEN_LINK_IN_NEW_TAB">Open Link in a New Tab </paper-radio-button>
              </paper-radio-group>
            </paper-cell>
          </template>

          <template is="dom-if" if="[[equal(step.id, 'qc_modules_selection_dialog')]]" restamp>
            <paper-cell slot="body" style="flex-basis:unset; flex-grow:unset;">
              <paper-checkbox checked="{{_itemData.qc_modules_selection_dialog}}">Allow user to select which modules to run</paper-checkbox>
            </paper-cell>
            <katapult-button
              color="var(--secondary-color)"
              slot="current-step-body"
              on-click="buttonSetTrue"
              path="_itemData.qc_modules_selection_dialog"
              style="margin-right: 8px"
              class="dialog-option"
              >Yes</katapult-button
            >
            <katapult-button
              color="var(--secondary-color)"
              slot="current-step-body"
              on-click="buttonSetFalse"
              path="_itemData.qc_modules_selection_dialog"
              class="dialog-option"
              >No</katapult-button
            >
          </template>

          <template is="dom-if" if="[[equal(step.id, 'tool_style')]]" restamp>
            <katapult-button on-click="chooseIcon" slot="body" style="margin-right: 8px;"
              ><iron-icon style$="color: [[_itemData.color]]; margin-right: 5px;" icon="[[_itemData.icon]]"></iron-icon
              ><span>Icon</span></katapult-button
            >
            <katapult-button on-click="chooseColor" slot="body" style="margin-right: 8px;"
              ><iron-icon style$="color: [[_itemData.color]]; margin-right: 5px;" icon="image:palette"></iron-icon
              ><span>Color</span></katapult-button
            >
            <katapult-button on-click="nextStep" slot="current-step-body">CONTINUE</katapult-button>
          </template>

          <template is="dom-if" if="[[equal(step.id, 'drawing_action')]]" restamp>
            <paper-radio-group selected="{{drawingAction}}" on-click="drawingActionClicked" slot="body">
              <paper-radio-button name="disconnected">Disconnected spans</paper-radio-button>
              <paper-radio-button name="connected">Connected spans</paper-radio-button>
              <paper-radio-button name="connected_polyline">Connected multi-point (polyline) spans</paper-radio-button>
            </paper-radio-group>
          </template>

          <template is="dom-if" if="[[equal(step.id, 'attributes')]]" restamp>
            <katapult-button on-click="nextStep" slot="current-step-header">Continue</katapult-button>
            <bind-path base="{{_itemData}}" path="[[step.type]].attributes" value="{{step.$attributes}}"></bind-path>
            <attribute-table
              attributes="[[attributesToArray(step.$attributes)]]"
              slot="body"
              other-attributes="[[otherAttributes]]"
              on-attributes-changed="attributesChanged"
              model-space-details="[[modelSpaceDetails]]"
            ></attribute-table>
          </template>

          <template is="dom-if" if="[[equal(step.id, 'prompt_attributes')]]" restamp>
            <bind-path base="{{_itemData}}" path="[[step.type]].open_for_editing" value="{{step.$openForEditing}}"></bind-path>
            <paper-cell icon slot="header">
              <paper-checkbox checked="{{step.$openForEditing}}"></paper-checkbox>
            </paper-cell>
            <katapult-button
              color="var(--secondary-color)"
              slot="current-step-body"
              on-click="buttonSetTrue"
              path="_itemData.[[step.type]].open_for_editing"
              style="margin-right: 8px"
              class="dialog-option"
              >Yes</katapult-button
            >
            <katapult-button
              color="var(--secondary-color)"
              slot="current-step-body"
              on-click="buttonSetFalse"
              path="_itemData.[[step.type]].open_for_editing"
              class="dialog-option"
              >No</katapult-button
            >
          </template>

          <template is="dom-if" if="[[equal(step.id, 'custom_function_editor_step')]]" restamp>
            <katapult-custom-function-editor-step
              other-attributes="[[otherAttributes]]"
              tool-item-data="[[_itemData]]"
              on-set-item-data="setItemDataFromCustomFunction"
              slot="body"
              style="width: 100%"
            ></katapult-custom-function-editor-step>
          </template>

          <template is="dom-if" if="[[equal(step.id, 'toolsets')]]" restamp>
            <katapult-button on-click="nextStep" slot="current-step-header" class="dialog-option">Skip</katapult-button>
            <div style="width: 400px; color: var(--primary-text-color-faded);" slot="body">
              <paper-table light-grey rounded outline>
                <paper-row input>
                  <paper-cell>
                    <katapult-drop-down
                      items="[[toolsets]]"
                      label-function="[[camelCaseKey]]"
                      value-path="$key"
                      label="Select a Toolset"
                      no-label-float
                      on-selected-changed="toolsetSelectedChanged"
                    >
                      <paper-item on-click="createNewToolset">CREATE NEW TOOLSET</paper-item>
                    </katapult-drop-down>
                  </paper-cell>
                </paper-row>
              </paper-table>
              <template is="dom-if" if="[[nullify(_itemData.toolsets, _itemData.toolsets.*)]]">
                <paper-table style="margin-top: 24px;" rounded outline white dividers>
                  <template is="dom-repeat" items="[[toArray(_itemData.toolsets, _itemData.toolsets.*)]]">
                    <paper-row>
                      <paper-cell>[[camelCase(item.$key)]]</paper-cell>
                      <paper-cell icon-button>
                        <katapult-button iconOnly noBorder icon="delete" on-click="removeFromToolset"></katapult-button>
                      </paper-cell>
                    </paper-row>
                  </template>
                </paper-table>
              </template>
            </div>
          </template>

          <template is="dom-if" if="[[equal(step.id, 'tags')]]" restamp>
            <katapult-button slot="current-step-body" on-click="nextStep" class="dialog-option" style="margin-left: 16px"
              >Skip</katapult-button
            >
            <paper-table light-grey style="width: 400px;" rounded outline slot="body">
              <paper-row input>
                <paper-cell>
                  <model-item-tag-selector
                    style="width: -webkit-fill-available;"
                    model-path="[[modelSpaceDetails.path]]"
                    modelCategory="tools"
                    item-key="[[itemKey]]"
                    tags="[[_itemData.tags]]"
                    on-change="tagSelectorChangeHandler"
                    mayAddTags
                    look-like-paper-element
                  ></model-item-tag-selector>
                </paper-cell>
              </paper-row>
            </paper-table>
          </template>
        </katapult-editor-step>
      </template>
      ${super.createItemContainer}
    `;
  }

  static get properties() {
    return {
      backup: {
        type: Object,
        value: {}
      },
      toolAction: {
        type: String,
        value: null
      },
      userGroup: String
    };
  }

  static get observers() {
    return [
      'updateToolAction(_itemData.node.*, _itemData.connection.*, _itemData.section.*, _itemData.qc_modules.*, _itemData.endpoint_url)',
      'updateTool(toolAction, drawingAction)',
      'updateModelsArray(_itemData.models, modelKeyValues)',
      'updateModelKeyValues(otherAttributes.*, _itemData.model_key_attribute)'
    ];
  }

  ready() {
    super.ready();

    this.keyMatchLabel = true;

    // An ordered list of all possible steps.
    this.setSteps([
      {
        id: 'tool_style',
        title: 'Tool Style'
      },
      {
        id: 'tool_action',
        title: 'Tool Action',
        trigger: () =>
          this.get('_itemData.node') != null ||
          this.get('_itemData.connection') != null ||
          this.get('_itemData.qc_modules') != null ||
          this.get('_itemData.endpoint_url') != null,
        if: () => this.get('_itemData.model_key_attribute') == null
      },
      {
        id: 'tool_configuration',
        title: 'Tool Configuration',
        if: () => this.get('_itemData.model_key_attribute') != null
      },
      {
        id: 'endpoint_url',
        title: 'Endpoint URL',
        if: () => this.toolAction == 'web_tool',
        trigger: () => this.get('_itemData.endpoint_url') != null
      },
      {
        id: 'endpoint_action',
        title: 'Endpoint Action',
        if: () => this.toolAction == 'web_tool',
        trigger: () => this.get('_itemData.endpoint_action') != null
      },
      {
        id: 'qc_modules',
        title: 'QC Modules',
        if: () => this.toolAction == 'run_qc_modules'
      },
      {
        id: 'qc_modules_selection_dialog',
        title: 'QC Modules Selection Dialog',
        if: () => this.toolAction == 'run_qc_modules',
        trigger: () => this.get('_itemData.qc_modules_selection_dialog') != null
      },
      {
        id: 'drawing_action',
        title: 'Drawing Action',
        if: () => this.toolAction == 'node_and_connection'
      },
      {
        id: 'attributes',
        type: 'node',
        title: 'Node Attributes',
        if: () => this.get('_itemData.node') != null
      },
      {
        id: 'prompt_attributes',
        type: 'node',
        title: 'Prompt User to Enter Added Node Attributes',
        if: () => this.get('_itemData.node.attributes') != null,
        trigger: () => this.get('_itemData.node.open_for_editing') != null
      },
      {
        id: 'attributes',
        type: 'connection',
        title: 'Connection Attributes',
        if: () => this.get('_itemData.connection') != null
      },
      {
        id: 'prompt_attributes',
        type: 'connection',
        title: 'Prompt User to Enter Added Connection Attributes',
        if: () => this.get('_itemData.connection.attributes') != null,
        trigger: () => this.get('_itemData.connection.open_for_editing') != null
      },
      {
        id: 'attributes',
        type: 'section',
        title: 'Section Attributes',
        if: () => this.get('_itemData.section') != null
      },
      {
        id: 'prompt_attributes',
        type: 'section',
        title: 'Prompt User to Enter Added Section Attributes',
        if: () => this.get('_itemData.section.attributes') != null,
        trigger: () => this.get('_itemData.section.open_for_editing') != null
      },
      {
        id: 'custom_function_editor_step',
        title: 'Custom Function Configuration', // This sets a default title for the custom function step
        if: () => this.hasCustomFunctionStep
      },
      {
        id: 'toolsets',
        title: 'Toolsets',
        trigger: () => this.get('_itemData.toolsets') != null
      },
      {
        id: 'tags',
        title: 'Tags',
        trigger: () => this.get('_itemData.tags') != null
      }
    ]);
  }

  attributesChanged(e) {
    // Rebuild attributes on _itemData when it changes.
    const attributes = {};
    const tableAttributes = e.currentTarget.attributes;
    for (const attr of tableAttributes) {
      const attribute = {};
      // If there is no attribute selected, then set the value to null
      let attributeValue = null;
      if (attr.attribute) {
        /* Otherwise get value set by the user.  If the value is null or an empty string, it means the user just added the attribute
           and there's no data for it. */
        attributeValue = attr.value;
        /* We should always run GetNewAttributeValue() on these newly added attributes because it'll either return
           the proper default values, or an empty string (which is what we had in the first place) */
        if (attributeValue === '' || attr.value === null) {
          attributeValue = GetNewAttributeValue(attr.attribute, this.otherAttributes);
          if (this.otherAttributes?.[attr.attribute]?.gui_element == 'table') {
            attributeValue = { [FirebaseWorker.ref().push().key]: attributeValue };
          }
        }
      }
      attribute.value = attributeValue;
      if (attr.picklist) attribute.picklist = attr.picklist;
      if (attributes[attr.attribute]) {
        // if the attribute has multiple values filter them to a list
        const keysWithValue = Object.keys(attributes[attr.attribute] || {}).filter((key) => key.includes('value')) || [];
        //add all values to the new attribute
        for (let key of keysWithValue) attribute[key] = attributes[attr.attribute][key];
        //do the same with picklists
        const keysWithPicklist = Object.keys(attributes[attr.attribute] || {}).filter((key) => key.includes('picklist')) || [];
        for (let key of keysWithPicklist) attribute[key] = attributes[attr.attribute][key];
        //get the next value number
        const nextValue = keysWithValue.length ? keysWithValue.length : 1;
        //add the new value to the attribute
        attribute[`value${nextValue}`] = attributeValue;
        attribute[`picklist`] = attr.picklist;
      }
      attributes[attr.attribute] = attribute;
    }
    this.set(`_itemData.${e.model.step.type}.attributes`, attributes);
  }

  chooseColor() {
    this.$.colorPickerDialog.color = this.get('_itemData.color');
    this.$.colorPickerDialog.open();
  }

  chooseIcon() {
    this.$.iconPickerDialog.open();
  }

  colorSelected(e) {
    this.set('_itemData.color', e.detail.color);
  }

  createNewToolset(e) {
    e.currentTarget.parentElement.close();
    document.dispatchEvent(new CustomEvent('create-new-toolset'));
  }

  drawingActionClicked(e) {
    if (e.model.step.index == this.currentIndex) this.nextStep();
  }

  iconSelected(e) {
    this.set('_itemData.icon', e.detail.icon);
  }

  _initializeNewItem() {
    this.set('_itemData.icon', 'create');
    this.set('_itemData.color', '#000');
  }

  labelChanged(label) {
    this.set('_itemData.label', label);
  }

  modelValueChanged(e) {
    let key = FirebaseEncode.encode(e.model.item.$key);
    this.set(`_itemData.models.${key}`, { default: e.detail.value });
  }

  removeFromToolset(e) {
    delete this._itemData.toolsets[e.model.item.$key];
    this.notifyPath('_itemData.toolsets');
  }

  qcModulesArraySorted(e) {
    // Make a copy of the array and mutate it as per the sort
    let modulesArrayCopy = this._itemData.qc_modules.slice();
    let removedItemsCopy = modulesArrayCopy.splice(e.detail.prevIndex, 1);
    modulesArrayCopy.splice(e.detail.index, 0, removedItemsCopy[0]);
    let movedItems = [];
    // Depending on whether the module is being moved forward or back, rearrange the relevant portion of modulesArray
    if (e.detail.prevIndex > e.detail.index)
      movedItems = [this._itemData.qc_modules[e.detail.prevIndex], ...this._itemData.qc_modules.slice(e.detail.index, e.detail.prevIndex)];
    else
      movedItems = [
        ...this._itemData.qc_modules.slice(e.detail.prevIndex + 1, e.detail.index + 1),
        this._itemData.qc_modules[e.detail.prevIndex]
      ];
    // Splice in the rearranged array and reorder the modules
    this.splice(`_itemData.qc_modules`, Math.min(e.detail.index, e.detail.prevIndex), movedItems.length, ...movedItems);
  }

  qcModuleSelectedChanged(e) {
    if (e.detail.value) {
      e.currentTarget.value = null;
      let moduleIndex = this._itemData.qc_modules.findIndex((x) => x.key == e.detail.value);
      if (moduleIndex == -1) {
        this.push('_itemData.qc_modules', { key: e.detail.value });
      }
    }
  }

  removeQCModule(e) {
    let moduleIndex = this._itemData.qc_modules.findIndex((x) => x.key == e.model.item.key);
    if (moduleIndex != -1) {
      this.splice('_itemData.qc_modules', moduleIndex, 1);
    }
  }

  add(num, amount) {
    return num + amount;
  }

  flattenedDataValidate(val, valKey, parentObject) {
    let result = super.flattenedDataValidate(val, valKey, parentObject);
    // allow the default value for multi-drop down attributes to be saved
    return result || valKey == '-k000';
  }

  async _saveUpdate(itemData, update, detail) {
    // Save the item first.
    await super._saveUpdate(itemData, update, detail);
    // Update all of the toolsets.
    await FirebaseWorker.ref(`${this.modelSpaceDetails.path}/models/button_groups`).transaction((toolsets) => {
      if (toolsets) {
        for (let key in toolsets) {
          let add = Path.get(itemData, `toolsets.${key}`) === true && toolsets[key][detail.itemKey] == null;
          let remove = Path.get(itemData, `toolsets.${key}`) !== true && toolsets[key][detail.itemKey] != null;
          // Get the toolset being modified.
          let toolset = toolsets[key];
          if (add || remove || detail.keyChanged) {
            // Append the new tool to the tool keys array.
            if (add) {
              toolset[detail.itemKey] = {};
            }
            // If the tool's key has changed, remove references to it's previous key.
            if (detail.keyChanged) {
              if (toolset[detail.previousKey] && itemData.toolsets[key])
                toolset[detail.itemKey] = structuredClone(toolset[detail.previousKey]);
              delete toolset[detail.previousKey];
            }
            // If we are removing the item from the toolset, go ahead and do that now.
            if (remove) delete toolset[detail.itemKey];
            // Calc an array of tool keys sorted by priority.
            let sortedKeys = Object.keys(toolset)
              .filter((key) => !key.startsWith('_'))
              .sort((a, b) => toolset[a].priority - toolset[b].priority);
            // Re-cal the priority of the tools.
            sortedKeys.forEach((key, i) => (toolset[key].priority = i));
          }
        }
        return toolsets;
      }
    });
  }

  toArray(x) {
    return ToArray(x);
  }

  toolsetSelectedChanged(e) {
    if (e.detail.value) {
      e.currentTarget.value = null;
      if (!this.get('_itemData.toolsets')) this.set('_itemData.toolsets', { [e.detail.value]: true });
      else this.set(`_itemData.toolsets.${e.detail.value}`, true);
    }
  }

  updateModelKeyValues(otherAttributesChangeRecord) {
    let attr = this.get('_itemData.model_key_attribute');
    if (attr) {
      let relevant = Path.startsWith(`otherAttributes.${attr}`, otherAttributesChangeRecord.path);
      if (relevant) {
        let picklists = this.get(`otherAttributes.${attr}.picklists`);
        let picklistValues = [];
        for (let key in picklists) {
          for (let i in picklists[key]) {
            picklistValues.push(picklists[key][i].value);
          }
        }
        this.modelKeyValues = picklistValues;
      }
    }
  }

  updateModelsArray() {
    if (Array.isArray(this.modelKeyValues)) {
      this.modelsArray = this.modelKeyValues.map(($key) => {
        return {
          $key,
          $val: this.get(`_itemData.models.${FirebaseEncode.encode($key)}.default`)
        };
      });
    }
  }

  updateTool() {
    if (this._itemData != null && this.toolAction != null) {
      let lazy = new LazySet(this);
      // Configure itemData.node
      if (['node', 'insert_node', 'node_and_connection'].includes(this.toolAction)) {
        if (this._itemData.node == null) lazy.set('_itemData.node', {});
        lazy.set('_itemData.node.location', 'new');
        lazy.set('_itemData.node.insert', this.toolAction == 'insert_node' ? true : null);
        if (this.drawingAction != null)
          lazy.set('_itemData.node.take_focus', !(this.toolAction == 'node_and_connection' && this.drawingAction == 'disconnected'));
        if (!this._itemData.node.attributes) lazy.set('_itemData.node.attributes', this.get('backup.node.attributes') || {});
      } else {
        if (this._itemData.node != null) this.set('backup.node', this._itemData.node);
        lazy.set('_itemData.node', null);
      }
      // Configure itemData.connection
      if (['connection', 'node_and_connection'].includes(this.toolAction)) {
        if (this._itemData.connection == null) lazy.set('_itemData.connection', {});
        lazy.set('_itemData.connection.location_1', 'active');
        lazy.set('_itemData.connection.location_2', this.toolAction == 'node_and_connection' ? 'new' : 'target');
        if (this.drawingAction != null) {
          lazy.set('_itemData.connection.polyline', this.drawingAction == 'connected_polyline' ? true : null);
        }
        if (!this._itemData.connection.attributes)
          lazy.set('_itemData.connection.attributes', this.get('backup.connection.attributes') || {});
      } else {
        if (this._itemData.connection != null) this.set('backup.connection', this._itemData.connection);
        lazy.set('_itemData.connection', null);
      }
      // Configure itemData.section
      if (['section'].includes(this.toolAction)) {
        lazy.set('_itemData.section', {
          location: 'new',
          take_focus: true,
          attributes: this.get('backup.section.attributes') || {}
        });
      } else {
        if (this._itemData.section != null) this.set('backup.section', this._itemData.section);
        lazy.set('_itemData.section', null);
      }
      // Configure itemData for web tools
      if (this.toolAction == 'web_tool') {
        // restore backups
        const endpointUrl = this._itemData.endpoint_url ?? this.get('backup.endpoint_url') ?? '';
        const endpointAction = this._itemData.endpoint_action ?? this.get('backup.endpoint_action') ?? '';
        lazy.set('_itemData.endpoint_url', endpointUrl);
        lazy.set('_itemData.endpoint_action', endpointAction);
      } else {
        // save backups
        if (this._itemData.endpoint_url != null) this.set('backup.endpoint_url', this._itemData.endpoint_url);
        if (this._itemData.endpoint_action != null) this.set('backup.endpoint_action', this._itemData.endpoint_action);
        lazy.set('_itemData.endpoint_url', null);
        lazy.set('_itemData.endpoint_action', null);
      }
      // Configure itemData.qc_modules
      if (this.toolAction == 'run_qc_modules') {
        lazy.set('_itemData.action', this.get('backup.action') || 'run_qc_modules');
        if (this._itemData.qc_modules == null) {
          lazy.set('_itemData.qc_modules', this.get('backup.qc_modules') || []);
        }
      } else {
        if (this.get('_itemData.action') != null) this.set('backup.action', this._itemData.action);
        if (this.get('_itemData.qc_modules') != null) this.set('backup.qc_modules', this._itemData.qc_modules);
        lazy.set('_itemData.action', null);
        lazy.set('_itemData.qc_modules', null);
      }
      // Notify paths (cannot do this before because buttionAction will be re-calculated while we are still responding to it being changed).
      lazy.notify();
    }
  }

  updateToolAction(a, b, c) {
    if (!this.creatingItem) {
      //this._itemData != null &&
      this.updateToolActionDebounce = Debouncer.debounce(this.updateToolActionDebounce, timeOut.after(10), () => {
        let toolAction = null;
        if (this.get('_itemData.function')) toolAction = 'custom_function';
        else if (this.get('_itemData.node') != null && this.get('_itemData.connection') != null) toolAction = 'node_and_connection';
        else if (this.get('_itemData.node.insert') === true) toolAction = 'insert_node';
        else if (this.get('_itemData.node') != null) toolAction = 'node';
        else if (this.get('_itemData.connection') != null) toolAction = 'connection';
        else if (this.get('_itemData.section') != null) toolAction = 'section';
        else if (this.get('_itemData.qc_modules') != null) toolAction = 'run_qc_modules';
        else if (this.get('_itemData.endpoint_url') != null || this.get('_itemData.endpoint_action') != null) toolAction = 'web_tool';
        this.toolAction = toolAction;

        let drawingAction = null;
        if (this.toolAction == 'node_and_connection') {
          if (this.get('_itemData.node.take_focus') === true) {
            if (this.get('_itemData.connection.polyline') === true) drawingAction = 'connected_polyline';
            else drawingAction = 'connected';
          } else {
            drawingAction = 'disconnected';
          }
        }
        this.drawingAction = drawingAction;

        if (this.toolAction == 'custom_function') {
          // get the data for the custom function's editor step
          const customFunctionStepData = KatapultCustomFunctionEditorStep.FUNCTION_TO_STEP_LOOKUP[this._itemData.function];
          this.hasCustomFunctionStep = customFunctionStepData != null;
          if (!this.hasCustomFunctionStep) return;

          // if the current step has a title, set it properly
          const stepTitle = customFunctionStepData.stepTitle;
          if (stepTitle == null) return;
          const customFunctionStepIndex = this.steps?.findIndex((step) => step.id === 'custom_function_editor_step');
          this.set(`steps.${customFunctionStepIndex}.title`, stepTitle);
        }
      });
    }
  }
  attributesToArray(attributes) {
    const attributesArray = [];
    for (const attribute in attributes) {
      for (const key in attributes[attribute]) {
        if (!key.includes('picklist')) {
          attributesArray.push({ attribute, value: attributes[attribute][key], picklist: attributes[attribute].picklist });
        }
      }
    }
    return attributesArray;
  }

  setItemDataFromCustomFunction(event) {
    const { path = '', value } = event.detail;
    this.set(Path.join(['_itemData', path]), value);
  }

  tagSelectorChangeHandler(e) {
    const tags = e.target.tags;
    this.set('_itemData.tags', tags);
  }
}

customElements.define('katapult-tool-editor', KatapultToolEditor);
